import HeaderNavItem from "src/components/base/header-nav/HeaderNavItem";
import HeaderNavGroup from "src/components/base/header-nav/HeaderNavGroup";
import HeaderNavItemTitle from "src/components/base/header-nav/HeaderNavItemTitle";

import { FaYoutube, FaMedium, FaChalkboardTeacher, FaBook, FaCertificate, FaCode, FaGamepad, FaBriefcase, FaHeart, FaFlask } from "react-icons/fa";

const header_nav = [
  // {
  //   component: HeaderNavGroup,
  //   name: "Content",
  //   items: [
  //     {
  //       component: HeaderNavItem,
  //       name: "YouTube",
  //       to: "/content/youtube",
  //       icon: <FaYoutube />,
  //       description: "Watch my tutorials (SimpleEPIC)",
  //     },
  //     {
  //       component: HeaderNavItem,
  //       name: "Medium",
  //       to: "/content/medium",
  //       icon: <FaMedium />,
  //       description: "Read my technical Blogs"
  //     },
  //     {
  //       component: HeaderNavItem,
  //       name: "Workshops",
  //       to: "/content/workshops",
  //       icon: <FaChalkboardTeacher />,
  //       description: "Check out my workshops & Techtalks"
  //     },
  //   ],
  // },
  {
    component: HeaderNavGroup,
    name: "Education",
    items: [
      {
        component: HeaderNavItem,
        name: "Academics",
        to: "/education/academics",
        icon: <FaBook />,
        description: "Explore my academic background and studies.",
      },
      {
        component: HeaderNavItem,
        name: "Certifications",
        to: "/education/certifications",
        icon: <FaCertificate />,
        description: "Discover my certifications and achievements.",
      },
    ],
  },
  {
    component: HeaderNavGroup,
    name: "Projects",
    items: [
      {
        component: HeaderNavItem,
        name: "Software",
        to: "/projects/software",
        icon: <FaCode />,
        description: "Check out my software projects",
      },
      {
        component: HeaderNavItem,
        name: "Game",
        to: "/projects/game",
        icon: <FaGamepad />,
        description: "Developed games & subsystems (UE)",
      },
    ],
  },
  {
    component: HeaderNavGroup,
    name: "Experience",
    to: "/experience",
    // icon: <FaBriefcase />,
  },
  {
    component: HeaderNavGroup,
    name: "Lifestyle",
    to: "/lifestyle",
    // icon: <FaHeart />,
  },
  {
    component: HeaderNavGroup,
    name: "Research",
    to: "/research",
    // icon: <FaFlask />,
  },
];

export default header_nav;
